import React, { useState } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { EntityLocationFormFields } from '../../forms';
import css from './EditListingLocationForm.css';
import { FieldCheckbox } from '../../components';
import { IconLockL } from '../../icons';
import { usePresavedInitialLocationValues } from './usePresavedInitialLocationValues';
import { useNewInitialLocationValues } from './useNewInitialLocationValues';
import { PREDICT_LOCATION_STEP } from '../EntityLocationFormFields/helpers';

const EditListingLocationPageOne = ({
    intl,
    values,
    currentListing,
    form,
    valid,
    setPredictionInProgress,
    setPredictAllowed,
}) => {
    const [step, setStep] = useState(PREDICT_LOCATION_STEP);

    usePresavedInitialLocationValues({ form, values, currentListing });

    useNewInitialLocationValues({ form, currentListing, values, step });

    return (
        <div>
            <h1 className={css.locationTypeTitle}>
                <FormattedMessage id="EditListingLocationForm.locationTypeTitle" />
            </h1>
            <p className={css.locationTypeSubTitle}>
                <FormattedMessage id="EditListingLocationForm.locationTypeSubTitle" />
            </p>

            <EntityLocationFormFields
                notifyOnChange={({ currentStep, predictAllowed, predictionInProgress }) => {
                    setStep(currentStep);
                    setPredictAllowed(predictAllowed);
                    setPredictionInProgress(predictionInProgress);
                }}
                form={form}
                values={values}
                valid={valid}
                noLocationFoundContent="Ich finde die Stalladresse nicht"
                locationFieldProps={{ placeholder: 'Stalladresse' }}
            />

            <div className={css.lockerWrapper}>
                <IconLockL />
                <FormattedMessage id="EditListingLocationForm.lockTitle" />
            </div>
            <div>
                <div className={css.mobilityContainer}>
                    <h4 className={css.mobilityTitle}>
                        <FormattedMessage id="EditListingLocationForm.mobilityTitle" />
                    </h4>
                </div>
                <FieldCheckbox
                    type="checkbox"
                    id="mobility"
                    name="mobility"
                    label={intl.formatMessage({
                        id: 'EditListingLocationForm.accessiblityTitle',
                    })}
                    value="mobility"
                    form={form}
                    togglerMode
                    reversePosition
                    isSingleElem
                />
            </div>
        </div>
    );
};

export default EditListingLocationPageOne;
